import React from 'react';

function BoltIcon ({ width = 7, height = 10, ...props }) {
  return (
    <svg width={width} height={height} {...props} viewBox="0 0 7 10">
      <g>
        <path d="M6.5847564,4.02386758 L4.12006453,3.97204593 L4.81203903,0.461791556 C4.84651315,0.288170138 4.74475219,0.102066134 4.56739738,0.0324662628 C4.39004257,-0.0371336085 4.18236715,0.00674457124 4.06856102,0.148970395 L0.0807776235,5.0920743 C-0.0122609643,5.20706539 -0.025967542,5.28158264 0.0450574514,5.40867806 C0.116082445,5.53577347 0.259378484,5.53690826 0.415550399,5.53690826 L2.88854929,5.60802117 L2.19075988,9.53171391 C2.15960857,9.70722663 2.26635374,9.89786975 2.44703135,9.96330876 C2.49687345,9.98184351 2.54920766,10 2.60071116,10 C2.73528483,10 2.86528965,9.94515228 2.94462166,9.83886117 L6.92825155,4.52581882 C7.01464452,4.41007121 7.02378224,4.29091926 6.9515112,4.16722818 C6.8796555,4.0435371 6.73843621,4.02386758 6.5847564,4.02386758 Z" />
      </g>
    </svg>
  );
}

export default BoltIcon;
